import * as React from 'react';
import { IAgentReviewsSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { Stars } from '@cian/stars-component';
import { mergeStyles, plural } from '@cian/utils';
import { prop } from 'ramda';

import { Link } from '../../common/components/link';
import { createAgentRate } from '../../utils/agent';

import * as styles from './index.css';

export interface IAgentStatsProps {
  link?: string;
  uniqueKey: string;
  large?: boolean;
  agentReviews?: IAgentReviewsSchema | null;
}

export function AgentStats({ agentReviews, uniqueKey, link, large }: IAgentStatsProps) {
  const rate = prop('entityRate', agentReviews as IAgentReviewsSchema);
  const reviews = prop('totalCount', agentReviews as IAgentReviewsSchema);

  return (
    <div {...mergeStyles(styles['stats'], large && styles['large'])}>
      {!!rate && (
        <div className={styles['rate']}>
          <div className={styles['rate-value']}>{createAgentRate(rate)}</div>
          <Stars
            percentage
            value={rate}
            uniqueKey={uniqueKey}
            unitClassName={styles['star']}
            containerClassName={styles['stars']}
          />
        </div>
      )}
      {!!rate && !!reviews && (
        <Link className={styles['reviews']} href={`${link}#reviews`}>
          {reviews} {plural(reviews, ['отзыв', 'отзыва', 'отзывов'])}
        </Link>
      )}
      {!reviews && <div className={styles['reviews']}>Нет отзывов</div>}
    </div>
  );
}
